import React from 'react';

import { Button, Group, Stack, useMantineTheme } from '@mantine/core';
import StaffAccountForm from 'components/AccountDetails/StaffAccountDetails/components/StaffAccountForm';
import ImageUploader from 'components/ImageUploader';
import { useAuth } from 'context/auth-context';
import SimpleHeader from 'layouts/MobileLayout/components/SimpleHeader';

import LogWorkCard from './components/LogWorkCard';

const AccountDetails = (): JSX.Element => {
  const theme = useMantineTheme();
  const { session, logout, clearProfile, stopImpersonation } = useAuth();

  const isImpersonating = session?.isImpersonating;

  return (
    <>
      <SimpleHeader title='Account' />
      <Stack className='content'>
        <ImageUploader />
        <StaffAccountForm />
        <LogWorkCard />
        <Group grow my='md' spacing='md'>
          {isImpersonating ? (
            <Button
              color='red'
              variant='light'
              onClick={stopImpersonation}
              size='sm'
              sx={{ boxShadow: theme.shadows.md }}
            >
              Stop Impersonation
            </Button>
          ) : (
            <Button variant='light' onClick={clearProfile} size='sm' sx={{ boxShadow: theme.shadows.md }}>
              Switch Profiles
            </Button>
          )}
          <Button
            color='red'
            variant='light'
            onClick={logout}
            size='sm'
            sx={{ boxShadow: theme.shadows.md }}
          >
            Log Out
          </Button>
        </Group>
      </Stack>
    </>
  );
};

export default AccountDetails;
